import { observer } from 'mobx-react-lite';
import { Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import Html from 'react-pdf-html';
import { renderToStaticMarkup } from 'react-dom/server';
import RenderComponent, {
  LastRenderComponent,
  SignatureRenderComponent,
} from './RenderComponent';
import { FilmData } from '../../../app/stores/FilmAnaysisAndRepairReport/types';
import { useEffect, useState } from 'react';

interface Props {
  totalPageCount: number;
  pageNumber: number;
  GroupData: FilmData[];
}
const styles = StyleSheet.create({
  page: {
    padding: 30,
  },
  pageNumber: {
    fontSize: '12px',
    position: 'absolute',
    bottom: 12,
    right: 10,
  },
  pdfView: {
    // Add styles for the View component here
    width: '100%', // Make the view take up the full width of the page
    height: '100%', // Make the view take up the full height of the page
    margin: 0, // Remove any margins
  },
  pdfHtml: {
    // Add styles for the Html component here
    width: '100%', // Make the HTML content take up the full width of the View
    height: '100%', // Make the HTML content take up the full height of the View
  },
});

const FilmRenderComponent: React.FC<Props> = ({
  pageNumber,
  totalPageCount,
  GroupData,
}) => {
  const [reelAnalysisStatus, setReelAnaysisStatus] = useState({
    filteredData: '',
    filteredData1: '',
  });
  const [followUpsTable, setFollowUpsTable] = useState<any[]>([]);

  useEffect(() => {
    if (!GroupData || GroupData.length === 0) return;
    const ReelAnaysisStatus: any = GroupData?.[0]?.reelAnalysisStatuses?.[0];
    const keys = Object.keys(ReelAnaysisStatus || {});
    const first12Keys = keys.slice(0, 12);
    const filteredData: any = {};
    const remainingData: any = {};
    keys.forEach((key) => {
      if (first12Keys.includes(key)) {
        filteredData[key] = ReelAnaysisStatus[key];
      } else {
        remainingData[key] = ReelAnaysisStatus[key];
      }
    });
    const filteredValue = {
      filteredData: filteredData,
      filteredData1: remainingData,
    };
    setReelAnaysisStatus(filteredValue);
    // eslint-disable-next-line
  }, [GroupData]);

  useEffect(() => {
    if (!GroupData || GroupData.length === 0) return;
    const extractedData: any[] = [];
    const firstGroup: any = GroupData[0]; // Get the first object in the array
    const movementToDesiccationData = firstGroup?.movementToDesiccation?.[0];
    const extractedItem: any = {
      movementToDesiccation: {
        editor_or_checker_name:
          movementToDesiccationData?.editor_or_checker_name || 'NA',
        date_and_time: movementToDesiccationData?.date_and_time || 'NA',
        intial_weight: movementToDesiccationData?.intial_weight || 'NA',
        unwinding_reel_status:
          movementToDesiccationData?.unwinding_reel_status || 'NA',
        rack_No_in_Chamber:
          movementToDesiccationData?.rack_No_in_Chamber || 'NA',
        shelf_No_in_Chamber:
          movementToDesiccationData?.shelf_No_in_Chamber || 'NA',
      },
    };

    for (let i = 1; i <= 32; i++) {
      const followupKey = `follow-up_${i}`;
      const followupData = firstGroup?.followuplists?.[i - 1];

      extractedItem[followupKey] = followupData
        ? {
            followup_editor_or_checker_Name:
              followupData.followup_editor_or_checker_Name || 'NA',
            followup_Date_and_Time: followupData.followup_Date_and_Time || 'NA',
            followup_weight: followupData.followup_weight || 'NA',
            followup_Unwinding_Reel_status:
              followupData.followup_Unwinding_Reel_status || 'NA',
          }
        : {
            followup_editor_or_checker_Name: 'NA',
            followup_Date_and_Time: 'NA',
            followup_weight: 'NA',
            followup_Unwinding_Reel_status: 'NA',
          };
    }

    extractedData.push(extractedItem);
    setFollowUpsTable(extractedData);
  }, [GroupData]);

  const FirstComponent: React.FC = () => (
    <>
      <RenderComponent
        title="Title Information:"
        elements={[GroupData[0]?.titleinformation?.[0] as any]}
        firstComponent={true}
      />
      <RenderComponent
        title="Asset Related Information:"
        elements={[GroupData[0]?.assetReportInforamtions?.[0] as any]}
      />
      <RenderComponent
        title="Reel Analysis Status:"
        elements={[reelAnalysisStatus?.filteredData as any]}
      />
    </>
  );
  const SecondComponent: React.FC = () => (
    <>
      <br />
      <br />
      <RenderComponent
        title={''}
        elements={[reelAnalysisStatus.filteredData1 as any]}
      />
      <RenderComponent
        title="Manual Repair Update:"
        elements={[GroupData[0]?.manualRepairUpdate?.[0] as any]}
      />
      <RenderComponent
        title="Manual Cleaning:"
        elements={[GroupData[0]?.manualCleaning?.[0] as any]}
      />
    </>
  );

  const ThirdComponentOne: React.FC = () => (
    <>
      <RenderComponent
        title={'Drying Or Desiccation / Rehydration Treatment:'}
        elements={[]}
        elementObject={followUpsTable as any}
        indexValue={0}
        dryingOrDesiccation={GroupData[0]?.dryingOrDesiccation?.[0]}
      />
    </>
  );
  const ThirdComponentTwo: React.FC = () => (
    <>
      <br />
      <br />
      <RenderComponent
        title={''}
        elements={[]}
        elementObject={followUpsTable as any}
        indexValue={1}
      />
    </>
  );
  const ThirdComponentThree: React.FC = () => (
    <>
      <br />
      <br />
      <RenderComponent
        title={''}
        elements={[]}
        elementObject={followUpsTable as any}
        indexValue={2}
      />
    </>
  );
  const ThirdComponentFour: React.FC = () => (
    <>
      <br />
      <br />
      <RenderComponent
        title={''}
        elements={[]}
        elementObject={followUpsTable as any}
        indexValue={3}
        dryingOrDesiccation={GroupData[0]?.dryingOrDesiccation?.[0]}
      />
    </>
  );

  const FourthComponent: React.FC = () => (
    <>
      <br />
      <br />
      <RenderComponent
        title="Ultra Sonic (Uc) Machine Cleaning:"
        elements={[GroupData[0]?.ultraSonicUCMachineCleaning?.[0] as any]}
      />
      <RenderComponent
        title="Rewash Machine:"
        elements={[GroupData[0]?.rewashMachine?.[0] as any]}
      />
      <LastRenderComponent
        elementObject={[GroupData[0]?.movementBacktoVault?.[0] as any]}
        title="Movement Back To Vault:"
      />
      <br />
    </>
  );
  const FifthComponent: React.FC = () => (
    <>
      <br />
      <br />
      <SignatureRenderComponent />
    </>
  );
  const FirstHtml = renderToStaticMarkup(<FirstComponent />);
  const SecondHtml = renderToStaticMarkup(<SecondComponent />);
  const htmlFour = renderToStaticMarkup(<FourthComponent />);
  const htmlFive = renderToStaticMarkup(<FifthComponent />);

  const ThreePageFirstHtml = renderToStaticMarkup(<ThirdComponentOne />);
  const ThreePageSecondHtml = renderToStaticMarkup(<ThirdComponentTwo />);
  const ThreePageThreeHtml = renderToStaticMarkup(<ThirdComponentThree />);
  const ThreePageFourHtml = renderToStaticMarkup(<ThirdComponentFour />);
  return (
    <>
      <Page>
        <View>
          <Html>{FirstHtml}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 1} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>

      <Page>
        <View>
          <Html>{SecondHtml}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 2} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>

      <Page>
        <View>
          <Html>{ThreePageFirstHtml}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 3} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>

      <Page>
        <View>
          <Html>{ThreePageSecondHtml}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 4} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>

      <Page>
        <View>
          <Html>{ThreePageThreeHtml}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 5} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>

      <Page>
        <View>
          <Html>{ThreePageFourHtml}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 6} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>

      <Page>
        <View>
          <Html>{htmlFour}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 7} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>

      <Page>
        <View>
          <Html>{htmlFive}</Html>
        </View>
        <Text style={styles.pageNumber}>{`Page ${pageNumber + 8} of ${
          totalPageCount * 8
        }`}</Text>
      </Page>
    </>
  );
};

export default observer(FilmRenderComponent);
